import { render } from "./LoaderButton.vue?vue&type=template&id=7f0d0030"
import script from "./LoaderButton.vue?vue&type=script&lang=js"
export * from "./LoaderButton.vue?vue&type=script&lang=js"
script.render = render

export default script